import { configure, LogLevelDesc } from '@js-boot/logger';
import { APP_CONFIG } from '../../config';

const debuggingActivated = () => new URLSearchParams(window.location.search).get('debug') === 'true';

const { getLogger, getDefaultLogger } = configure({
  level: debuggingActivated() ? 'debug' : (APP_CONFIG.logLevel as LogLevelDesc) || 'silent',
  http: {
    url: `${APP_CONFIG.apiEndpoint}/frontend-logs`,
    additionalFetchProperties: {
      credentials: 'include',
    },
  },
  console: {
    enabled: false,
  },
});

export { getLogger, getDefaultLogger };
